/* eslint-disable react/prop-types */
import { useDispatch } from "react-redux";
import licenseDetails from '../../../../assets/licenseDetails.json';
import Page from "../../../../components/Page";
import Layout from "../../../../layouts";
import { setLicenseData } from "../../../../redux/slices/gplx.quiz";
import HomeCar from "../../../../sections/gplx/HomeCar";
import HomeMotoBike from '../../../../sections/gplx/HomeMotoBike';
import { findLicenseTypesAPI } from "../../../../service/gplx.licenseType.service";
import { checkLicense } from "../../../../utils/checkLicense";
import { licenseDataArray } from "../../../../utils/licenses";

License.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function License({ license, type, licenseTypes }) {
  const dispatch = useDispatch();
  const licenseIndex = checkLicense(license);
  const { name: licenseName, time, correctAnswers, totalExams } = licenseDetails[licenseIndex];

  dispatch(setLicenseData({
    licenseIndex,
    licenseName,
    licenseRequirement: {
      time: time,
      correctAnswers: correctAnswers,
    },
    totalExams: totalExams
  }));

  if (type === licenseDataArray[4][0]) {// o to 
    const title = `Thi GPLX ô tô - Hạng bằng ${licenseName}`;
    return (
      <Page title={title} description={title} imagePath="/slider/lo-trinh-hoc-xe-oto.jpg">
        <HomeCar licenseTypes={licenseTypes} />
      </Page>
    );
  } else {
    const title = `Thi GPLX xe máy - Hạng bằng ${licenseName}`;
    return (
      <Page title={title} description={title} imagePath="/slider/lo-trinh-hoc-xe-may.jpg">
        <HomeMotoBike licenseTypes={licenseTypes} />
      </Page>
    );
  }
}

export async function getStaticPaths() {
  let paths = [];

  licenseDataArray[4].forEach((type) => {
    paths = paths.concat(licenseDataArray[3].map((license) => ({
      params: {
        license: `hang-bang-${license}`,
        type
      }
    })));
  });

  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const license = params.license.substring(10);
  const type = params.type;

  const search = { page: 0, size: 12, value: '%%', orders: [{ order: 'asc', property: 'orderNo' }] };
  const { code, data: licenseTypes } = await findLicenseTypesAPI(search);

  if (code !== "200") {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      license,
      type,
      licenseTypes
    },
  };
}
